//问题表单中问题类型
export const questionRegFormTypehood = [
  {
    type:1,
    value:'单选'
  },
  {
    type:2,
    value:'多选'
  },
  {
    type:3,
    value:'数字'
  },
  {
    type:4,
    value:'手机号'
  },
  {
    type:5,
    value:'身份证号'
  },
  {
    type:6,
    value:'邮箱'
  },
  {
    type:7,
    value:'单行文本'
  },
  {
    type:8,
    value:'多行文本'
  },
  {
    type:9,
    value:'图片'
  }
]
// 展示中的片position 未知
export const positionList = [{
  type:'INDEX',
  value:'首页'
}]
export const getPositionValue =(type) =>{
  if(!type){
    return ''
  }
  const position = positionList.find((item)=>item.type===type)
  return position&&position.value || type
}
// 横幅中的mode
export const modeList = [{
  type:'large',
  value:'大'
},{
  type:'small',
  value:'小'
}]
export const getModeValue =(type) =>{
  return modeList.find((item)=>item.type===type).value
}
// 订单状态
export const orderSteps = [
  {
    label: '待付款',
    value: 1,
  },
  {
    label: '已付款',
    value: 2,
  },
  {
    label: '已发货',
    value: 3,
  },
  {
    label: '已核销',
    value: 4,
  },
  {
    label: '已退款',
    value: 5,
  },
  {
    label: '已取消',
    value: 6,
  },
  {
    label: '退款中',
    value: 8,
  },
]
export const orderChannelOptions = [
  {
    label: '微信支付',
    value: 'WEPAY',
  },
  {
    label: '线下支付',
    value: 'OFFLINEPAY',
  },
  {
    label: '未知',
    value: 'UNKOWN',
  },
]
export const orderChannels = {
  WEPAY: '微信支付',
  OFFLINEPAY: '线下支付',
  UNKOWN: '未知'
}
export const orderTypehoods = [
  {
    label: '商品订单',
    key: 'product',
    value: 1,
  },
  {
    label: '公寓订单',
    key: 'apartment',
    value: 2,
  },
]
//游戏类型
export const gameType = [{value:1,label:'扫码'},{value:2,label:'分享'},{value:3,label:'注册会员'},{value:4,label:'完成调查问卷'}]
// 公寓相关
export const apartmentTags = ['近地铁', '有家具', '近公交']
export const facilityList = ['电视', '冰箱', '微波炉', '空调', '电饭煲', '独卫', '淋浴', '浴缸']
